// Presentational pieces of the Fair-Play panel (see FairPlay.js).
import React from 'react';

export const COLORS = { watch: '#FFC107', suspicious: '#FF9800', confirmed: '#f44336', none: '#9e9e9e' };
export const card = { background: '#fff', border: '1px solid #e3e6ea', borderRadius: 10, padding: 14, marginBottom: 14 };
export const th = { textAlign: 'left', padding: '6px 8px', fontSize: 12, color: '#666', borderBottom: '1px solid #eee' };
export const td = { padding: '6px 8px', fontSize: 13, borderBottom: '1px solid #f3f3f3', verticalAlign: 'top' };
export const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', borderRadius: 6, padding: '5px 10px', fontSize: 12, cursor: 'pointer', marginRight: 6 });

export const StatCards = ({ today }) => (
  <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
    {[['Games checked', today.gamesAnalysed], ['Games flagged', today.gamesFlagged], ['New flags', today.newFlags],
      ['Confirmed', today.bySeverity.confirmed], ['Money held (USD)', today.moneyHeldUsd], ['Open holds', today.openRecoveries]].map(([k, v]) => (
      <div key={k} style={{ ...card, marginBottom: 0, flex: '1 1 130px', textAlign: 'center' }}>
        <div style={{ fontSize: 22, fontWeight: 700 }}>{v}</div>
        <div style={{ fontSize: 12, color: '#666' }}>{k} <span style={{ color: '#aaa' }}>({today.date})</span></div>
      </div>
    ))}
  </div>
);

export const ReportsTable = ({ reports }) => (
  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    <thead><tr><th style={th}>Date</th><th style={th}>Games checked</th><th style={th}>Flagged</th><th style={th}>New flags</th><th style={th}>Confirmed</th><th style={th}>Held (USD)</th></tr></thead>
    <tbody>{reports.map(r => (
      <tr key={r.date}><td style={td}>{r.date}</td><td style={td}>{r.gamesAnalysed}</td><td style={td}>{r.gamesFlagged}</td>
        <td style={td}>{r.newFlags}</td><td style={td}>{r.bySeverity.confirmed}</td><td style={td}>{r.moneyHeldUsd}</td></tr>))}</tbody>
  </table>
);

export const FlagsTable = ({ flags, superAdmin, busy, act, api }) => (
  flags.length === 0 ? <p style={{ color: '#888' }}>No flags — everything looks fair.</p> : (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead><tr><th style={th}>When</th><th style={th}>Winner</th><th style={th}>Helper(s)</th><th style={th}>Level</th><th style={th}>Why</th><th style={th}>Money</th><th style={th}>Status</th></tr></thead>
      <tbody>{flags.map(f => (
        <tr key={f.id}>
          <td style={td}>{new Date(f.createdAt).toLocaleString()}<div style={{ color: '#999', fontSize: 11 }}>game #{f.gameId}</div></td>
          <td style={td}>{f.beneficiary.username}</td>
          <td style={td}>{f.helpers.map(h => h.username).join(', ')}</td>
          <td style={td}><span style={{ background: COLORS[f.severity], color: '#fff', borderRadius: 10, padding: '2px 8px', fontSize: 11 }}>{f.severity} · {Math.round(f.score * 100)}%</span></td>
          <td style={td}><ul style={{ margin: 0, paddingLeft: 16 }}>{f.reasons.map((r, i) => <li key={i}>{r}</li>)}</ul></td>
          <td style={td}>{f.moneyGame ? `looted ≈ $${f.lootUsd}${f.seized ? ' (held)' : ''}` : 'no money'}</td>
          <td style={td}>{f.status}
            {superAdmin && f.status === 'open' && !(f.recoveries || []).some(r => r.status === 'held') && (
              <div><button disabled={busy} style={btn('#757575')} onClick={() => act('Dismiss this flag?', () => api(`/flags/${f.id}/status`, 'POST', { status: 'dismissed' }))}>Dismiss</button></div>)}
          </td>
        </tr>))}</tbody>
    </table>
  )
);

export const HeldTable = ({ rows, busy, act, api }) => (
  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    <thead><tr><th style={th}>Player</th><th style={th}>Held</th><th style={th}>Owed to others</th><th style={th}>Affected players</th><th style={th}>Action</th></tr></thead>
    <tbody>{rows.map(r => (
      <tr key={r.id}>
        <td style={td}>{r.username}</td>
        <td style={td}>{r.amountLocal} {r.currency} (≈ ${r.amountUsd})</td>
        <td style={td}>${r.owedUsd}</td>
        <td style={td}>{(r.victims || []).map(v => `#${v.userId}`).join(', ') || '—'}</td>
        <td style={td}>
          <button disabled={busy} style={btn('#2e7d32')} onClick={() => act('Refund the held money to the affected players?', () => api(`/recoveries/${r.id}/refund`, 'POST'))}>Refund victims</button>
          <button disabled={busy} style={btn('#607d8b')} onClick={() => act(`Release the hold back to ${r.username}? (use when the flag was wrong)`, () => api(`/recoveries/${r.id}/release`, 'POST', { note: 'Released by super admin' }))}>Release to player</button>
        </td>
      </tr>))}</tbody>
  </table>
);
